import type { ProductType } from '@atlaskit/linking-common';

export const JIRA_PRODUCTS: ProductType[] = ['JSM', 'JWM', 'JSW', 'JPD'];
